"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SpinnerType = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _loadingCoin = _interopRequireDefault(require("./loading-icons/loading-coin"));

var _loadingN = _interopRequireDefault(require("./loading-icons/loading-n"));

var _loadingWallet = _interopRequireDefault(require("./loading-icons/loading-wallet"));

var _genericSpinner = _interopRequireDefault(require("./loading-icons/generic-spinner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SpinnerType = {
  GENERIC: 'generic',
  COIN: 'coin',
  N: 'n',
  WALLET: 'wallet'
};
exports.SpinnerType = SpinnerType;
var TYPES = [SpinnerType.COIN, SpinnerType.N, SpinnerType.WALLET, SpinnerType.GENERIC];

var LoadingSpinner = function LoadingSpinner(_ref) {
  var type = _ref.type,
      className = _ref.className,
      color = _ref.color,
      inline = _ref.inline,
      size = _ref.size;

  switch (type) {
    case SpinnerType.COIN:
      return _react["default"].createElement(_loadingCoin["default"], {
        className: className
      });

    case SpinnerType.N:
      return _react["default"].createElement(_loadingN["default"], {
        className: className,
        size: size
      });

    case SpinnerType.GENERIC:
      return _react["default"].createElement(_genericSpinner["default"], {
        color: color,
        inline: inline,
        size: size
      });

    case SpinnerType.WALLET:
    default:
      return _react["default"].createElement(_loadingWallet["default"], {
        className: className
      });
  }
};

LoadingSpinner.displayName = 'LoadingSpinner';
LoadingSpinner.propTypes = {
  type: _propTypes["default"].oneOf(TYPES),
  className: _propTypes["default"].string,
  // deprecated, and does not affect type="generic"

  /**
   * "color" currently only affects type="generic". Feel free to expand to other loading types if
   * you are willing to implement.
   */
  color: _propTypes["default"].oneOf(['white', 'green', 'grey']),
  // re-defined here to get around docgen
  inline: _propTypes["default"].bool,
  // currently only implemented for type="generic"

  /**
   *  "size" currently only affects type="n" and type="generic". Feel free to expand to other types
   *  if you are willing to implement the aspect ratio lockin for those spinners
   */
  size: _propTypes["default"].number
};
LoadingSpinner.defaultProps = {
  className: null,
  color: 'white',
  inline: false,
  size: 100,
  type: null
};
var _default = LoadingSpinner;
exports["default"] = _default;